import { useState } from "react"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { SelectionEntity } from "../../Objects/Selection/SelectionEntity"
import { SelectionOptionEntity } from "../../Objects/Selection/SelectionOptionEntity"

export const useCreateSelection = () => {
  const [name, setName] = useState("")

  const [description, setDescription] = useState("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [options, setOptions] = useState<SelectionOptionEntity[]>([])

  const [allowMultiple, setAllowMultiple] = useState(false)

  const [isRequired, setIsRequired] = useState(false)

  const [requiredOptionsCount, setRequiredOptionsCount] = useState("1")

  const [freeOptionsLimit, setFreeOptionsLimit] = useState("0")

  const [hasMaximumSelectionsLimit, setHasMaximumSelectionsLimit] = useState(false)

  const [maximumSelectionsLimit, setMaximumSelectionsLimit] = useState("1")

  const handleInitialValue = (selection?: SelectionEntity) => {
    if (!selection) {
      setName("")
      setDescription("")
      setStatus(EEnableStatusType.Active)
      setOptions([])
      setAllowMultiple(false)
      setIsRequired(false)
      setRequiredOptionsCount("1")
      setFreeOptionsLimit("0")
      setHasMaximumSelectionsLimit(false)
      setMaximumSelectionsLimit("1")
      return
    }

    setName(selection.name)
    setDescription(selection.description)
    setStatus(selection.status)
    setOptions(selection.options.map((option) => new SelectionOptionEntity(option)))
    setAllowMultiple(selection.allowMultiple)
    setIsRequired(selection.isRequired)
    setRequiredOptionsCount((selection.requiredOptionsCount ?? 1).toString())
    setFreeOptionsLimit((selection.freeOptionsLimit ?? 0).toString())
    setHasMaximumSelectionsLimit(selection.hasMaximumSelectionsLimit ?? false)
    setMaximumSelectionsLimit((selection.maximumSelectionsLimit ?? 1).toString())
  }

  const handleSubmitForm = (selectionId?: number) => {
    const sanitizedOptions = options.map(
      (option) =>
        new SelectionOptionEntity({
          ...option,
          allowMultiple: allowMultiple && option.allowMultiple,
          maximumSelectionsLimit:
            allowMultiple && option.allowMultiple ? Number(option.maximumSelectionsLimit || 0) : 1,
        }),
    )

    return new SelectionEntity({
      id: selectionId,
      name,
      description,
      status,
      options: sanitizedOptions,
      allowMultiple,
      isRequired,
      requiredOptionsCount: allowMultiple ? Number(requiredOptionsCount || 0) : 1,
      freeOptionsLimit: allowMultiple ? Number(freeOptionsLimit || 0) : 0,
      hasMaximumSelectionsLimit: allowMultiple && hasMaximumSelectionsLimit,
      maximumSelectionsLimit: allowMultiple && hasMaximumSelectionsLimit ? Number(maximumSelectionsLimit || 0) : 0,
    })
  }

  return {
    name,
    setName,
    description,
    setDescription,
    status,
    setStatus,
    options,
    setOptions,
    allowMultiple,
    setAllowMultiple,
    isRequired,
    setIsRequired,
    requiredOptionsCount,
    setRequiredOptionsCount,
    freeOptionsLimit,
    setFreeOptionsLimit,
    hasMaximumSelectionsLimit,
    setHasMaximumSelectionsLimit,
    maximumSelectionsLimit,
    setMaximumSelectionsLimit,
    handleInitialValue,
    handleSubmitForm,
  }
}
